if (!customElements.get('product-card-variants')) {
  customElements.define(
    'product-card-variants',
    class ProductCardVariants extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.controller = new AbortController();
        this.addEventListener('change', this.onChange.bind(this), { signal: this.controller.signal });

        const selected = this.querySelector('[data-merch-variant]:checked');
        if (selected) this.applyVariant(selected, false);
      }

      disconnectedCallback() {
        this.controller?.abort();
        delete this.dataset.initialized;
      }

      onChange(event) {
        const input = event.target.closest('[data-merch-variant]');
        if (!input || !this.contains(input)) return;
        this.applyVariant(input, true);
      }

      applyVariant(input, announce) {
        const scope = this.closest('[data-variant-card]') || this;
        const available = input.dataset.available === 'true';
        const comparePrice = input.dataset.comparePrice || '';
        const sellingPrice = input.dataset.price || '';
        const variantId = input.dataset.variantId;

        const sellingLabel = this.querySelector('[data-merch-selling-label]');
        const sellingPriceNode = this.querySelector('[data-merch-selling-price]');
        const compareWrap = this.querySelector('[data-merch-compare-wrap]');
        const comparePriceNode = this.querySelector('[data-merch-compare-price]');
        const status = this.querySelector('[data-merch-selection-status]');

        if (sellingLabel) sellingLabel.textContent = comparePrice ? 'Sale price' : 'Price';
        if (sellingPriceNode) sellingPriceNode.textContent = sellingPrice;
        if (compareWrap) compareWrap.hidden = !comparePrice;
        if (comparePriceNode) comparePriceNode.textContent = comparePrice;
        if (status) {
          status.textContent = announce
            ? `${input.dataset.variantSize} selected. ${available ? 'Available.' : 'Sold out.'}`
            : '';
        }

        this.dataset.selectedVariantId = variantId;
        scope.querySelectorAll('[data-variant-target-id]').forEach((target) => {
          target.value = variantId;
          target.disabled = !available;
        });
        scope.querySelectorAll('[data-variant-add]').forEach((button) => {
          button.disabled = !available;
          button.setAttribute('aria-disabled', String(!available));
          button.dataset.variantId = variantId;
          const text = button.querySelector('[data-variant-add-text]');
          if (text) text.textContent = available ? (text.dataset.availableText || 'Add to cart') : 'Sold out';
          if (button.dataset.productTitle) {
            button.setAttribute(
              'aria-label',
              available
                ? `Add ${button.dataset.productTitle}, ${input.dataset.variantSize} to bag`
                : `${button.dataset.productTitle}, ${input.dataset.variantSize} is sold out`
            );
          }
        });
        scope.querySelectorAll('[data-variant-link]').forEach((link) => {
          link.href = input.dataset.variantUrl;
        });

        const image = scope.querySelector('[data-variant-image]');
        if (image && input.dataset.image) {
          image.src = input.dataset.image;
          image.removeAttribute('srcset');
        }

        this.dispatchEvent(
          new CustomEvent('banic:card-variant-change', {
            bubbles: true,
            detail: { variantId, available, sellingPrice, comparePrice },
          })
        );
      }
    }
  );
}
